import React, { Component }  from 'react';


export const createAvatar = (className, name = '') => {
    var firstChar = name ? name.substr(0, 1).toUpperCase() : 'R';

    return (
        <div className={`avatar-flex-center ${className}` }>{firstChar}</div>
    )
}